import $ from 'jquery';
window.jQuery = $;
window.$ = $;

class CookieConsent {

    constructor(element) {
        console.log('CookieConsent.constructor', element);
        this.element = element;
        this.btn = this.element.getElementsByClassName('cookieconsent-ui')[0].getElementsByTagName('button')[0];
        console.log('CookieConsent.button', this.btn);
        this.btnClickHandler = this.btnClickHandler.bind(this);
        this.btn.addEventListener("click", this.btnClickHandler);
    }

    destroy() {
        console.log('CookieConsent.destroy', this.element);
        this.btn.removeEventListener("click", this.btnClickHandler);
    }

    btnClickHandler(event) {
        console.log('CookieConsent.btnClickHandler', event, event.currentTarget);
        event.preventDefault();
        this.element.classList.add('disabled');
        $(this.element).mabCookieSet();
    }
}

CookieConsent.elementClassName = 'cookie-consent';
CookieConsent.instances = [];
CookieConsent.init = function () {
    console.log('CookieConsent.init');
    var elements = document.getElementsByClassName(CookieConsent.elementClassName);
    for (const element of Array.from(elements)) {
        CookieConsent.instances.push(new CookieConsent(element));
    }
    console.log('CookieConsent.instances.length', CookieConsent.instances.length);
};

CookieConsent.onDispose = function () {
    console.log('CookieConsent.onDispose');
    while (CookieConsent.instances.length) {
        console.log('CookieConsent.instances.length', CookieConsent.instances.length);
        let instance = CookieConsent.instances.pop();
        instance.destroy();
        instance = null;
    }
};

export default CookieConsent;

if (module.hot) {
    module.hot.dispose(CookieConsent.onDispose);
}
